import { Controller } from "@hotwired/stimulus"

// Toggles between up to three view modes for a recipe collection.
// Targets are optional — only the views you wire are toggled.
//
// Wire with: data-controller="view-toggle"
//            data-view-toggle-storage-key-value="someView"
//            data-view-toggle-default-value="list"
//            data-view-toggle-active-class="bg-warm-600 text-white"
//            data-view-toggle-inactive-class="text-gray-400"
export default class extends Controller {
  static targets = ["grid", "list", "swipe", "gridButton", "listButton", "swipeButton"]
  static classes = ["active", "inactive"]
  static values = {
    storageKey: { type: String, default: "recipeView" },
    default:    { type: String, default: "grid" }
  }

  connect() {
    const saved = localStorage.getItem(this.storageKeyValue) || this.defaultValue
    this.show(this.#allowedViews.includes(saved) ? saved : this.defaultValue)
  }

  showGrid()  { this.show("grid") }
  showList()  { this.show("list") }
  showSwipe() { this.show("swipe") }

  show(view) {
    localStorage.setItem(this.storageKeyValue, view)

    if (this.hasGridTarget)  this.gridTarget.classList.toggle("hidden",  view !== "grid")
    if (this.hasListTarget)  this.listTarget.classList.toggle("hidden",  view !== "list")
    if (this.hasSwipeTarget) this.swipeTarget.classList.toggle("hidden", view !== "swipe")

    if (this.hasGridButtonTarget)  this.#paint(this.gridButtonTarget,  view === "grid")
    if (this.hasListButtonTarget)  this.#paint(this.listButtonTarget,  view === "list")
    if (this.hasSwipeButtonTarget) this.#paint(this.swipeButtonTarget, view === "swipe")
  }

  // Stimulus' singular `activeClass` getter only returns the first token of a
  // multi-class string ("bg-warm-600 text-white" → "bg-warm-600"), so we walk
  // the plural `activeClasses` array to toggle every class together.
  #paint(button, active) {
    this.activeClasses.forEach(c   => button.classList.toggle(c, active))
    this.inactiveClasses.forEach(c => button.classList.toggle(c, !active))
  }

  get #allowedViews() {
    const views = []
    if (this.hasGridTarget  || this.hasGridButtonTarget)  views.push("grid")
    if (this.hasListTarget  || this.hasListButtonTarget)  views.push("list")
    if (this.hasSwipeTarget || this.hasSwipeButtonTarget) views.push("swipe")
    return views.length ? views : ["grid", "list"]
  }
}
